module.exports = __webpack_public_path__ + "img/category-chemical.609b3d4b.png";